import { render, staticRenderFns } from "./IconCopyLink.vue?vue&type=template&id=5ec294b5"
import script from "./IconCopyLink.vue?vue&type=script&lang=js"
export * from "./IconCopyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports